import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const AppleBoldIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        fill={color}
        d="M28.893,24.01c-0.705,1.562-1.042,2.258-1.95,3.638c-1.265,1.927-3.05,4.327-5.262,4.347 c-1.965,0.018-2.47-1.278-5.137-1.263c-2.667,0.015-3.223,1.287-5.188,1.268c-2.212-0.02-3.902-2.187-5.168-4.115 c-3.54-5.388-3.91-11.712-1.727-15.073c1.552-2.39,4-3.787,6.302-3.787c2.343,0,3.817,1.285,5.755,1.285 c1.88,0,3.025-1.287,5.735-1.287c2.048,0,4.218,1.115,5.765,3.042C22.952,14.842,23.775,22.075,28.893,24.01L28.893,24.01z"
      />
      <path
        data-color="color-2"
        fill={color}
        d="M20.484,5.651c0.985-1.263,1.732-3.047,1.46-4.87c-1.608,0.11-3.488,1.133-4.587,2.467 c-0.997,1.21-1.82,3.005-1.5,4.75C17.612,8.053,19.429,7.005,20.484,5.651L20.484,5.651z"
      />
    </svg>
  );
};
